import React, { useEffect, useState } from "react";
import { consultingFields, subFields } from "./RSheetsConsultingModel";
import Button from "components/CustomButtons/Button";
import RSheetsConsultingFormActions from "./RSheetsConsultingFormActions";
import FormElement from "../RSheetsFormElement";
import { Dialog } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { connect } from "react-redux";
import * as actions from "store/actions";
import { commatize } from "shared/utility";
import {
    calculateAbatedRanges as calculateAbatedRanges2,
    calculateAbatedValues,
    calculateAdjustedCommission,
    calculateEstimatedAbatedRanges,
    calculateEstimatedTermsTotal,
    calculateLeaseTermTotal,
    calculateTermsTotal,
    generateCommissionSplitData,
    isEstimatedLease,
    calculateAbatedRanges_RS as calculateAbatedRanges,
    calculateLeaseLogic_RS as calculateLeaseLogic,
    calculateStartingRent,
    makeAllRanges,
    makeTotalCalcs,
    getDateDifference,
    getAbatedTotal,
    typeDescriptionsDict,
} from "../RSheetsLogic";
import { get, isEmpty, sortBy } from "lodash";
import { currencyToNumber, formatDollar } from "../../../shared/utility";

import Lessees from "./CustomElements/Lessees";
import Lessors from "./CustomElements/Lessors";

import InvoicePayment from "../CommonCustomElements/InvoicePayment";
import FileLoading from "../CommonCustomElements/FileLoading";
import FileUpload from "../CommonCustomElements/FileUpload";
import Term from '../CommonCustomElements/Term/Term';
import OtherReferrals from "../CommonCustomElements/OtherReferrals";
import GuarantorsDisplay from "../CommonCustomElements/GuarantorsDisplay";
import BrokersFullForm, { calculateBrokerCommission } from "../CommonCustomElements/BrokersLogic";
import { commissionCalc } from "../CommonCustomElements/CommissionLogic";
import { CommissionSplitsAssociateFull } from "../CommonCustomElements/CommissionSplits";
import OutsideBrokersForm, { ReferralsForm } from "../CommonCustomElements/OthersForm";
import { CommissionDistributionFull } from "../CommonCustomElements/CommissionDistribution";
import { PresplitsFormFull } from "../CommonCustomElements/PreSplitsForm";
import PaymentScheduleFullForm from "../CommonCustomElements/PaymentScheduleFullForm";
import CommissionAdjustmentTable from "../CommonCustomElements/CommissionAdjustmentTable";

import { sectionNames } from "./RSheetsConsultingModel";
const stepNames = {} 
Object.keys(sectionNames).forEach(num => {
    stepNames[sectionNames[num]] = parseInt(num);
})
console.log('stepNames Consulting', stepNames);

const renderLabel = (field, data, subType, overrideLabel) => {
    if (overrideLabel) {
        return (
            <div>
                <strong>{overrideLabel}</strong> : {data[field]}
            </div>
        );
    }
    return (
        <div>
            <strong>{subFields[subType][field] ? subFields[subType][field].label : ''}</strong> : {data[field]}
        </div>
    );
};

const RSheetsConsultingFormFull = (props) => {
    const [fieldEdit, setFieldEditValue] = useState(null);
    const [calculatedAbatedRanges, setCalculatedAbatedRanges] = useState(null);
    const [editOtherReferrals, setEditOtherReferrals] = useState(null);
    const { data, updateDataObj, updateDataMultiObj, setData } = props;

    const diffObj = getDateDifference(data);

    const isFlatFee = data.flat_fee_commission === "Yes";

    const hasLesseeAssociate = get(data, 'illi_represented_lessee', '') !== 'No'
    const hasLessorAssociate = get(data, 'illi_represented_lessor', '') !== 'No'

    useEffect(() => {
        generateCommissionSplitData(data, setData)
    }, [])

    useEffect(() => {
        const calc = calculateAbatedRanges({
            lease_term: data.lease_term,
            abated: data.abated_rent_ranges,
        });
        setCalculatedAbatedRanges(calc);
    }, [data.lease_term, data.abated_rent_ranges]);

    const setFieldEdit = (field) => {
        if (!props.viewOnly) setFieldEditValue(field);
    };
    const make = (field, showLabel = true) => {
        const prefix =
            consultingFields[field] !== undefined &&
            consultingFields[field].prefix &&
            consultingFields[field].prefix ? (
                <span>{consultingFields[field].prefix}</span>
            ) : (
                ""
            );
        let value = get(data, field, "");

        return (
            <span className="hoverable fullform">
                {consultingFields[field] !== undefined && showLabel && (
                    <strong>
                        {consultingFields[field].label} : {prefix}
                    </strong>
                )}
                <span className="editables">{value}</span>
            </span>
        );
    };

    const makeCheckboxes = (field) => {
        return (
            <span>
                {consultingFields[field] &&
                    consultingFields[field].options &&
                    consultingFields[field].options.map((o, i) => {
                        if (!o) return null;
                        if (data[field] === 0) {
                            return (
                                <span className="grayed ml-10 hoverable fullform" key={`${field}-${o}-${i}`}>
                                    <input type="checkbox" key={`${o}-checkbox-${field}`} checked={true} readOnly />
                                    &nbsp;{o}
                                </span>
                            );
                        }
                        if (data[field] && data[field] !== undefined) {
                            if (data[field].indexOf(o) !== -1) {
                                return (
                                    <span className="grayed ml-10 hoverable fullform" key={`${field}-${o}-${i}`}>
                                        <input type="checkbox" key={`${o}-checkbox-${field}`} checked={true} readOnly />
                                        &nbsp;{o}
                                    </span>
                                );
                            }
                        }
                        return (
                            <span className="grayed ml-10 hoverable fullform" key={`${field}-${o}-${i}`}>
                                <input type="checkbox" key={`${o}-checkbox-${field}`} checked={false} readOnly />
                                &nbsp;{o}
                            </span>
                        );
                    })}
            </span>
        );
    };

    const makeArray = (field, key) => {
        if (!data[field]) return null;
        if (key === "multi-dates") {
            return (
                <ul className="list-unstyled">
                    {data[field].map((m, i) => {
                        let all_total = 0;
                        let total_abated = 0;
                        if (field === "lease_term") {
                            if (data.abated_rent_ranges) {
                                if (data.abated_rent_ranges[i]) {
                                    const tot = getAbatedTotal(data.abated_rent_ranges[i]);
                                    total_abated += tot;
                                }
                            }
                        }
                        return (
                            <li key={`${i}-${field}-year`}>
                                <div>
                                    <h4>Year {m.year_num}</h4>
                                    {m.ranges.length === 0 && (
                                        <div>
                                            <em>None</em>
                                        </div>
                                    )}
                                    {m.ranges.map((mr, j) => {
                                        const { value, date1, date2, commissionRate } = mr;
                                        const calcs = calculateLeaseLogic({
                                            date1,
                                            date2,
                                            value,
                                            data,
                                        });
                                        let allTotal = 0;
                                        calcs.forEach((cc) => {
                                            allTotal += cc.calcRounded;
                                        });
                                        all_total += allTotal;
                                        return (
                                            <div key={`${j}-range-${i}`}>
                                                <span>
                                                    {mr.date1} to {mr.date2}
                                                </span>{" "}
                                                - ${commatize(mr.value, true)}
                                                {field === "lease_term" && (
                                                    <div>
                                                        {commissionRate ? commatize(commissionRate, true) : 0}%
                                                        commission rate
                                                    </div>
                                                )}
                                                <hr />
                                            </div>
                                        );
                                    })}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            );
        } else if (key === "multi-contact") {
            if (field === "lessee_contacts" || field === "lessor_contacts") {
                return (
                    <ul className="list-unstyled">
                        {data[field].map((m, i) => {
                            const a = m;
                            let contactPhone = renderLabel("main_phone", a, field, 'Main Phone');
                            if (a.phone_type === 'Mobile') {
                                contactPhone = renderLabel("mobile_phone", a, field, 'Mobile Phone');
                            } else if (a.phone_type === 'Work') {
                                contactPhone = renderLabel("work_phone", a, field, 'Work Phone');
                            }
                            return (
                                <li key={`${i}-${field}`}>
                                    <div className="bordered-thin">
                                        {field === "lessee_contacts" && (
                                            <div>
                                                {renderLabel("name", a, "lessee")}
                                                {renderLabel("last_name", a, "lessee")}
                                                {renderLabel("address1", a, "lessee")}
                                                {renderLabel("email", a, "lessee")}
                                                {contactPhone}
                                            </div>
                                        )}
                                        {field === "lessor_contacts" && (
                                            <div>
                                                {renderLabel("name", a, "lessor")}
                                                {renderLabel("last_name", a, "lessor")}
                                                {renderLabel("address1", a, "lessor")}
                                                {renderLabel("email", a, "lessor")}
                                                {contactPhone}
                                            </div>
                                        )}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                );
            } else {
                return (
                    <ul className="list-unstyled">
                        {data[field].map((m, i) => {
                            return (
                                <li key={`${i}-${field}`}>
                                    <div className="bordered-thin">
                                        Name: {m.name} {m.last_name}
                                        <br />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                );
            }
        } else if (key === "name") {
            let html = ``;
            if (data[field]) {
                html = data[field]
                    .map((m) => {
                        return m.name + " " + m.last_name;
                    })
                    .join(", ");
            }
            return html;
        } else {
            let html = ``;
            if (data[field]) {
                html = data[field].map((m) => m[key]).join(", ");
            }
            return html;
        }
    };

    const renderElement = (field) => {
        return (
            <FormElement
                field={field}
                data={data}
                updateDataObj={updateDataObj}
                updateDataMultiObj={updateDataMultiObj}
                sheetType="Consulting"
                setData={setData}
                components={{
                    FileLoading: FileLoading,
                    FileUpload: FileUpload,
                    InvoicePayment: InvoicePayment,
                    Lessees: Lessees,
                    Lessors: Lessors,
                    Term: Term,
                }}
                canEditInvoiceRelatedData={props.canEditInvoiceRelatedData}
            />
        );
    };

    const renderLessors = () => {
        const model = subFields.lessor;
        const sort = ["name", "last_name", "phone", "email", "address1", "address2", "state", "city", "zip"];
        return (
            <div>
                {data.lessors.map((dl, i) => {
                    const sortedKey = sortBy(Object.keys(dl), (item) => {
                        const index = sort.indexOf(item);
                        return item === "guarantors" ? 2000 : (index === -1 ? 1000 : index);
                    });
                    return (
                        <div key={`${i}-lessor`}>
                            <h4>Lessor/Seller {i + 1}</h4>
                            {sortedKey.map((field) => {
                                // HIDE UNSELECTED
                                if (dl.phone_type) {
                                    if (dl.phone_type === 'Work') {
                                        if (field === 'mobile_phone' || field === 'main_phone') return null;
                                    } else if (dl.phone_type === 'Mobile') {
                                        if (field === 'work_phone' || field === 'main_phone') return null;
                                    } else if (dl.phone_type === 'Main') {
                                        if (field === 'work_phone' || field === 'mobile_phone') return null;
                                    }
                                } else {
                                    if (field === 'work_phone' || field === 'mobile_phone') return null;
                                }

                                if (dl.guarantor !== "Yes" && (field === "guarantor_name" || field === "guarantor_spouse_name" || field === "upload_guarantor_id")) return null;
                                if (field === "guarantors") return <GuarantorsDisplay guarantor={dl.guarantor} guarantors={dl.guarantors} key="guarantors-disp" />;
                                if (field === "id" || !model[field] || !model[field]) return null;
                                return (
                                    <div key={`${field}-lfield`}>
                                        <strong>{model[field].label}</strong> :{" "}
                                        <span>{dl[field] ? dl[field] : "n/a"}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    };

    const renderLessees = () => {
        const model = subFields.lessee;
        const sort = ["name", "last_name", "phone", "email", "address1", "address2", "state", "city", "zip"];
        return (
            <div>
                {data.lessees.map((dl, i) => {
                    const sortedKey = sortBy(Object.keys(dl), (item) => {
                        const index = sort.indexOf(item);
                        return item === "guarantors" ? 2000 : (index === -1 ? 1000 : index);
                    });
                    return (
                        <div key={`${i}-lessee`}>
                            <h4>Lessee/Buyer {i + 1}</h4>
                            {sortedKey.map((field) => {
                                // HIDE UNSELECTED
                                if (dl.phone_type) {
                                    if (dl.phone_type === 'Work') {
                                        if (field === 'mobile_phone' || field === 'main_phone') return null;
                                    } else if (dl.phone_type === 'Mobile') {
                                        if (field === 'work_phone' || field === 'main_phone') return null;
                                    } else if (dl.phone_type === 'Main') {
                                        if (field === 'work_phone' || field === 'mobile_phone') return null;
                                    }
                                } else {
                                    if (field === 'work_phone' || field === 'mobile_phone') return null;
                                }

                                if (dl.guarantor !== "Yes" && (field === "guarantor_name" || field === "guarantor_spouse_name" || field === "upload_guarantor_id")) return null;
                                if (field === "guarantors") return <GuarantorsDisplay guarantor={dl.guarantor} guarantors={dl.guarantors} key="guarantors-disp" />;
                                if (field === "id" || !model[field] || !model[field]) return null;

                                return (
                                    <div key={`${field}-lfield`}>
                                        <strong>{model[field].label}</strong> :{" "}
                                        <span>{dl[field] ? dl[field] : "n/a"}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    };

    const all_commission_calculations = commissionCalc.calculate(data, 'consulting');
    console.log('all_commission_calculations', all_commission_calculations);

    return (
        <div style={{ padding: 40, maxWidth: 900, margin: "0 auto" }}>
            <RSheetsConsultingFormActions
                data={data}
                setData={props.setData}
                id={null}
                viewOnly={props.viewOnly}
                setOpenedForm={props.setOpenedForm}
                setFormDataObj={props.setFormDataObj}
                setActivityTracker={props.setActivityTracker}
                closeTheForm={props.closeTheForm}
                level={props.level}
                tab={props.tab}
                updateDataObj={props.updateDataObj}
                save={props.save}
                the_invoices={props.the_invoices}
            />
            <div>
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            <td className="col-10">
                                <img
                                    src="https://illicre.com/wp-content/themes/zoacres/assets/illi-logo-simple.png"
                                    style={{ width: 60 }}
                                />
                            </td>
                            <td className="col-90">
                                <div className="text-center">
                                    <h3>ROUTING SHEET - CONSULTING</h3>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-20"
                                onClick={() => {
                                    setFieldEdit("date");
                                }}
                            >
                                {make("date")}
                            </td>
                            <td
                                className="col-60"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("project_name")}
                            </td>
                            <td
                                className="col-20"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("illi_number")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-80 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("project_address")}
                            </td>
                            <td className="col-20 no-bt" onClick={() => { props.setSomewhere(1); }}>{make('pm_number')}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-80 no-bt bold"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                Is Property Located in the City of L.A ?
                            </td>
                            <td
                                className="col-20 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {makeCheckboxes("la_city_verification")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-50 no-bt">
                                <strong>Can deal be submitted to Public Relations ? : </strong>
                                {makeCheckboxes("can_deal_be_submitted_to_public_relations")}
                            </td>
                            <td class="col-50 no-bt">
                                {make("can_deal_be_submitted_to_public_relations_comment")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    setFieldEdit("illi_represented_lessor");
                                }}
                            >
                                <strong>illi Represented Lessor/Seller :</strong>
                                {makeCheckboxes("illi_represented_lessor")}
                            </td>
                            <td
                                className="col-60 no-bt"
                                onClick={() => {
                                    setFieldEdit("illi_represented_lessor_agents");
                                }}
                            >
                                <strong>Associate(s)</strong> : {makeArray("illi_represented_lessor_agents", "name")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    setFieldEdit("illi_represented_lessee");
                                }}
                            >
                                <strong>illi Represented Lessee/Buyer : </strong>
                                {makeCheckboxes("illi_represented_lessee")}
                            </td>
                            <td
                                className="col-60 no-bt"
                                onClick={() => {
                                    setFieldEdit("illi_represented_lessee_agents");
                                }}
                            >
                                <strong>Agent(s)</strong> : {makeArray("illi_represented_lessee_agents", "name")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-100 no-bt">
                                <span
                                    onClick={() => {
                                        props.setSomewhere(1);
                                        //setFieldEdit("type_of_lease");
                                    }}
                                >
                                    <strong>Deal Type : </strong>
                                    {makeCheckboxes("type_of_lease")}
                                </span>
                                {data.type_of_lease === "Other" && (
                                    <span
                                        className="ml-20"
                                        onClick={() => {
                                            setFieldEdit("type_of_lease_other");
                                        }}
                                    >
                                        {/* <strong>Deal Type : </strong> */}
                                        {make("type_of_lease_other")}
                                    </span>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            <br />
            <div>
                <h4 style={{ textDecoration: "underline" }}>PROPERTY INFORMATION</h4>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-60"
                                onClick={() => {
                                    props.setSomewhere(2);
                                }}
                            >
                                {make("premises_address")}
                            </td>
                             <td
                                className="col-40"
                                onClick={() => {
                                    props.setSomewhere(2);
                                }}
                            >
                                {make("unit_number")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
           
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("city")}
                            </td>
                            <td
                                className="col-30 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("zip")}
                            </td>
                            <td
                                className="col-30 no-bt"
                                onClick={() => {
                                    props.setSomewhere(1);
                                }}
                            >
                                {make("county")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

			<div className="the-table">
              <table>
                  <tbody>
                      <tr>
                          <td className="col-100 no-bt" onClick={() => { setFieldEdit("property_type") }}>
                              {make("property_type")}
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>

          <div onClick={() => {
            props.setSomewhere(8);
          }}>
            <CommissionAdjustmentTable data={data} />
          </div>

            <br />
            <br />

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>LESSOR/SELLER</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>LESSEE/BUYER</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {/* {Lessee and Lessor} */}
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-45"
                                style={{ verticalAlign: "top" }}
                                onClick={() => {
                                    props.setSomewhere(5, 'lessors');
                                }}
                            >
                                {renderLessors()}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                            <td
                                className="col-45"
                                style={{ verticalAlign: "top" }}
                                onClick={() => {
                                    props.setSomewhere(4, 'lessees');
                                }}
                            >
                                {renderLessees()}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>LESSOR/SELLER CONTACTS</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>LESSEE/BUYER CONTACTS</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            {data.lessor_contacts && (
                                <td
                                    className="col-45"
                                    onClick={() => {
                                        props.setSomewhere(5, 'lessor_contacts');
                                    }}
                                >
                                    {makeArray("lessor_contacts", "multi-contact")}
                                    {data.lessor_contacts.length === 0 && (
                                        <div className="text-center">
                                            <em>N/A</em>
                                        </div>
                                    )}
                                </td>
                            )}
                            <td className="col-5 no-bt no-bb"></td>
                            {data.lessee_contacts && (
                                <td
                                    className="col-45"
                                    onClick={() => {
                                        props.setSomewhere(4, 'lessee_contacts');
                                    }}
                                >
                                    {makeArray("lessee_contacts", "multi-contact")}
                                    {data.lessee_contacts.length === 0 && (
                                        <div className="text-center">
                                            <em>N/A</em>
                                        </div>
                                    )}
                                </td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="the-table">
                <table width="100%">
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb vtop"
                                onClick={() => {
                                    props.setSomewhere(5, 'lessor_brokers');
                                }}
                            >
                                <BrokersFullForm 
                                    data={data}
                                    title="LESSOR"
                                    field="lessor_outside_broker"
                                />
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb vtop"
                                onClick={() => {
                                    props.setSomewhere(4, 'lessee_brokers');
                                }}
                            >
                                <BrokersFullForm 
                                    data={data}
                                    title="LESSEE"
                                    field="outside_broker"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>LESSOR/SELLER REFERRAL</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: "underline" }}>LESSEE/BUYER REFERRAL</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {[
                "company_name",
                "name",
                "lastname",
                "address1",
                "city",
                "state",
                "zip",
                "contact",
                "main_phone",
                "fax",
                "email",
                "taxid",
                "w9",
            ].map((ff, i) => {
                const r = `referral_firm_${ff}`;
                const o = `lessee_referral_firm_${ff}`;
                const add = i === 0 ? `` : `no-bt`;
                if (ff === "w9") {
                    return (
                        <div className="the-table" key={`${ff}-rto`}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td
                                            className={`col-45 ${add}`}
                                            onClick={() => {
                                                props.setSomewhere(5, 'lessor_referrals');
                                            }}
                                        >
                                            <strong>W9 : </strong>
                                            {makeCheckboxes(r)}
                                        </td>
                                        <td className="col-5 no-bt no-bb"></td>
                                        <td
                                            className={`col-45 ${add}`}
                                            onClick={() => {
                                                props.setSomewhere(4, 'lessee_referrals');
                                            }}
                                        >
                                            <strong>W9 : </strong>
                                            {makeCheckboxes(o)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                }
                return (
                    <div className="the-table" key={`${ff}-rto`}>
                        <table>
                            <tbody>
                                <tr>
                                    <td
                                        className={`col-45 ${add}`}
                                        onClick={() => {
                                            props.setSomewhere(5, 'lessor_referrals');
                                        }}
                                    >
                                        {make(r)}
                                    </td>
                                    <td className="col-5 no-bt no-bb"></td>
                                    <td
                                        className={`col-45 ${add}`}
                                        onClick={() => {
                                            props.setSomewhere(4, 'lessee_referrals');
                                        }}
                                    >
                                        {make(o)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            })}
            <br />
            
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: 'underline' }}>OTHER LESSOR/SELLER REFERRAL(S)</h4>
                            </td>
                            <td className="col-5 no-bt no-bb no-br"></td>
                            <td className="col-45 no-bt no-br no-bl no-bb">
                                <h4 style={{ textDecoration: 'underline' }}>OTHER LESSEE/BUYER REFERRAL(S)</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td className="col-45" onClick={() => { props.setSomewhere(5, 'lessor_referrals'); }}>
                                {data?.lessor_referrals && data?.lessor_referrals.map((ref, i) => {
                                    return <div>
                                        <h4>Referral #{i + 2}</h4>
                                        {['name', 'lastname', 'contact_dba_name', 'address1', 'city', 'state', 'zip', 'contact', 'main_phone', 'fax', 'email', 'taxid', 'w9'].map((fld) => {
                                            const field = `referral_firm_${fld}`;
                                            return <div>
                                                <strong>{consultingFields[field].label}</strong> : {ref[fld]}
                                            </div>
                                        })}
                                    </div>
                                })}
                                {(!data?.lessor_referrals || data?.lessor_referrals.length === 0) && <div className="text-center"><em>N/A</em></div>}
                            </td>
                            <td className="col-5 no-bt no-bb"></td>
                                <td className="col-45" onClick={() => { props.setSomewhere(4, 'lessee_referrals'); }}>
                                {data?.lessee_referrals && data?.lessee_referrals.map((ref, i) => {
                                    return <div>
                                        <h4>Referral #{i + 2}</h4>
                                        {['name', 'lastname', 'contact_dba_name', 'address1', 'city', 'state', 'zip', 'contact', 'main_phone', 'fax', 'email', 'taxid', 'w9'].map((fld) => {
                                            const field = `lessee_referral_firm_${fld}`;
                                            return <div>
                                                <strong>{consultingFields[field].label}</strong> : {ref[fld]}
                                            </div>
                                        })}
                                    </div>
                                })}
                                {(!data?.lessee_referrals || data?.lessee_referrals.length === 0) && <div className="text-center"><em>N/A</em></div>}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br />
            <div>
                <h4 style={{ textDecoration: "underline" }}>COMMISSION DISTRIBUTION PRE-SPLIT</h4>
            </div>
            <div onClick={() => {
                props.setSomewhere(3);
            }}>
                <PresplitsFormFull
                    data={data}
                />
            </div>
            <br />
            <br />
            
            <div onClick={() => {
                props.setSomewhere(6);
            }}>
                <CommissionDistributionFull 
                    fieldType="lessor"
                    name="LESSOR"
                    hasLessorAssociate={hasLessorAssociate}
                    data={data}
                />
            </div>
            <div className="mt-10" onClick={() => {
                props.setSomewhere(5, 'lessor_brokers');
            }}>
                <OutsideBrokersForm 
                    tableData={all_commission_calculations.lessor_outside_brokers}
                />
            </div>
            <div className="mt-10" onClick={() => {
                props.setSomewhere(5, 'lessor_referrals');
            }}>
                <ReferralsForm 
                    tableData={all_commission_calculations.lessor_referrals}
                />
            </div>
            <br />
            <br />

            <div onClick={() => {
                props.setSomewhere(6);
            }}>
                <CommissionDistributionFull 
                    fieldType="lessee"
                    name="LESSEE"
                    hasLesseeAssociate={hasLesseeAssociate}
                    data={data}
                />
            </div>
            <div className="mt-10" onClick={() => {
                props.setSomewhere(4, 'lessee_brokers');
            }}>
                <OutsideBrokersForm 
                    tableData={all_commission_calculations.lessee_outside_brokers}
                />
            </div>
            <div className="mt-10" onClick={() => {
                props.setSomewhere(4, 'lessee_referrals');
            }}>
                <ReferralsForm 
                    tableData={all_commission_calculations.lessee_referrals}
                /> 
            </div>

            <br />
            <br />
            <div onClick={() => {
                props.setSomewhere(6);
            }}>
                <CommissionSplitsAssociateFull 
                    all_commission_calculations={all_commission_calculations}
                />
            </div>
            <br />

            <br />
            <br />

            <br />
            <div>
                <h4 style={{ textDecoration: "underline" }}>BILLING INFORMATION</h4>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-50"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_attention")}
                            </td>
                            <td
                                className="col-50"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_attention_lastname")}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="col-50"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_company")}
                            </td>
                            <td className="col-50"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-50 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_address1")}
                            </td>
                            <td
                                className="col-50 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_address2")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_city")}
                            </td>
                            <td
                                className="col-40 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_state")}
                            </td>
                            <td
                                className="col-20 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_zip")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-20 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_phone")}
                            </td>
                            <td
                                className="col-20 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_fax")}
                            </td>
                            <td
                                className="col-60 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("billing_email")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-100 no-bt"
                                onClick={() => {
                                    props.setSomewhere(stepNames["Billing Information"]);
                                }}
                            >
                                {make("flat_fee_commission_amount")}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br />
            <br />
            <div>
                <h4 style={{ textDecoration: "underline" }}>COPY OF INVOICE</h4>
            </div>
            <div className="the-table">
                <table>
                    <tbody>
                        <tr>
                            <td
                                className="col-100"
                                onClick={() => {
                                    setFieldEdit("copy_of_invoice");
                                }}
                            >
                                <strong>Copy of Invoice : </strong>
                                {makeCheckboxes("copy_of_invoice")}
                            </td>
                        </tr>
                        {data.copy_of_invoice.indexOf("Other") !== -1 && (
                            <tr>
                                <td
                                    className="col-100"
                                    onClick={() => {
                                        setFieldEdit("copy_of_invoice_other");
                                    }}
                                >
                                    <strong>Other : </strong>
                                    {make("copy_of_invoice_other")}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <br />
            <br />
            {data.payment_schedule && (
                <div
                    className="hoverable"
                    onClick={() => {
                        if (props.setSomewhere) props.setSomewhere(stepNames["Payment Schedule"]);
                    }}
                >
                    <h4 style={{ textDecoration: "underline" }}>PAYMENT SCHEDULE</h4>
                    
                    <PaymentScheduleFullForm 
                        data={data}
                        sheetType={typeDescriptionsDict['Consulting']}
                        the_invoices={props.the_invoices}
                    />

                </div>
            )}

            <br />
            <br />
            <div>
                <h4 style={{ textDecoration: "underline" }}>COMMENTS AND SPECIAL INSTRUCTIONS</h4>
                <div
                    style={{ marginTop: 20 }}
                    onClick={() => {
                        setFieldEdit("comments_and_special_instructions");
                    }}
                >
                    <div className="the-table">
                        <table>
                            <tbody>
                                <tr>
                                    {data.comments_and_special_instructions &&
                                    data.comments_and_special_instructions.length === 0 ? (
                                        <td className="col-100">No Comments and Special Instructions</td>
                                    ) : (
                                        <td className="col-100">{data.comments_and_special_instructions}</td>
                                    )}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {fieldEdit && (
                <Dialog
                    open={fieldEdit ? true : false}
                    onClose={() => setFieldEdit(null)}
                    fullWidth={true}
                    maxWidth="md"
                >
                    <div
                        style={{
                            padding: 40,
                            margin: "0 auto",
                            width: "100%",
                            maxWidth: "1400px",
                            minHeight: 500,
                        }}
                    >
                        <div
                            className="close-btn"
                            onClick={() => {
                                setFieldEdit(null);
                            }}
                        >
                            <Close />
                        </div>
                        {consultingFields[fieldEdit] ? <h2>{consultingFields[fieldEdit].label}</h2> : <h2></h2>}
                        {renderElement(fieldEdit)}
                        <hr />
                        <Button
                            color="primary"
                            onClick={() => {
                                setFieldEdit(null);
                            }}
                        >
                            OK
                        </Button>
                        <Button
                            color="white"
                            onClick={() => {
                                setFieldEdit(null);
                            }}
                        >
                            CLOSE
                        </Button>
                    </div>
                </Dialog>
            )}

            {editOtherReferrals && <Dialog
                open={editOtherReferrals ? true : false}
                onClose={() => setEditOtherReferrals(null)}
                fullWidth={true}
                maxWidth="md"
            >
                <div style={{ padding: 40, margin: '0 auto', width: '100%', maxWidth: '1400px', minHeight: 500 }}>
                    <div className="close-btn" onClick={() => { setEditOtherReferrals(null) }}><Close /></div>
                    <OtherReferrals data={data} setData={setData} title={`OTHER ${editOtherReferrals === 'lessor' ? 'LESSOR/SELLER' : 'LESSEE/BUYER' } REFERRAL(S)`} name={`${editOtherReferrals}_referrals`} />
                    <Button color="primary" onClick={() => { setEditOtherReferrals(null) }}>OK</Button>
                    <Button color="white" onClick={() => { setEditOtherReferrals(null) }}>CLOSE</Button>
                </div>
            </Dialog>}

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        error: state.rs.error,
        success: state.rs.success,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createRsheet: (data) => {
            dispatch(actions.createRsheet(data));
        },
        getRsheets: (params) => {
            dispatch(actions.getRsheets(params));
        },
        updateRsheet: (params) => {
            dispatch(actions.updateRsheet(params));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RSheetsConsultingFormFull);
